export default "__VITE_ASSET__CHaJ777a__"